






























































































































import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import GenericButton from '@/components/GenericButton.vue';
import {Prop, Vue, Watch} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {CommercialAccount, Organisation, Role, User} from '@/types';
import AccountService from '@/services/account.service';
import {Getter} from 'vuex-class';

@Component({
  components: {CancelButton, ConfirmButton, GenericButton},
})
export default class AccountOrganisationAccess extends Vue {
  @Getter private activeAccountId: any;
  @Prop() private currentUser!: User;
  @Prop() private orgsToAdd!: any[];
  @Prop() private orgRoles!: Role[];
  private accountOrganisations: Organisation[] = [];
  private defaultRoles: Role[] = [];
  private newOrgs: any = [];
  private user: any | null = null;
  private loading: boolean = false;

  @Watch('currentUser', {immediate: true, deep: true})
  private onUserChange() {
    this.user = {...this.currentUser};
  }

  private async mounted() {
    this.loading = true;
    try {
      this.accountOrganisations = await AccountService.getAccountOrganisations(this.activeAccountId);
    } finally {
      this.loading = false;
    }
  }

  private get orgs() {
    return this.accountOrganisations || [];
  }

  private addOrgAccess() {
    this.newOrgs.push({ name: '' });
  }

  private removeNewOrganisation(org: Organisation) {
    this.$emit('addOrgs', this.orgsToAdd.filter((o: Organisation) => o.id !== org.id));
  }

  private async removeOrganisationAccess(org: Organisation) {
    if (this.accountOrganisations && this.accountOrganisations.length) {
      this.$emit('keepOrgs', this.accountOrganisations.filter((o: Organisation) => o.id !== org.id) || []);
      this.$emit('removeOrgs', this.user.organisations.filter((o: Organisation) => o.id !== org.id) || []);
    }
  }

  private async addOrganisationAccess(org: Organisation) {
    if (this.user) {
      const orgsToAdd = this.orgsToAdd || [];
      orgsToAdd.push({...org, roles: [this.orgRoles.find((r: Role) => r.slug === 'user')]});
      this.$emit('addOrgs', orgsToAdd);
      this.newOrgs = [];
    }
  }

  private addAllOrgs(user: { organisations: Organisation[] } | null) {
    if (user && this.accountOrganisations && this.accountOrganisations.length) {
      const existingOrgIds = new Set(this.user.organisations.map((org: Organisation) => org.id));
      this.newOrgs = [];
      this.$emit('addOrgs', this.accountOrganisations
          .filter((org) => !existingOrgIds.has(org.id))
          .map((o) => ({
            ...o,
            roles: [this.orgRoles.find((r: Role) => r.slug === 'user')],
          })) as Organisation[]);
    }
  }

  private removeAllOrgs(user: { organisations: Organisation[] } | null) {
    if (user) {
      this.user.organisations = [];
      this.newOrgs = [];
      this.$emit('addOrgs', []);
      this.$emit('removeOrgs', []);
    }
  }

  private setDefaultRoles() {
    this.user.organisations.forEach((org: { roles: Role[] }) => {
      org.roles = this.defaultRoles;
    });
    this.orgsToAdd.forEach((org: { roles: Role[] }) => {
      org.roles = this.defaultRoles;
    });
  }

  private get filteredOrganisations() {
    if (!this.accountOrganisations || !this.accountOrganisations.length || !this.currentUser) {
      return [];
    }
    return this.accountOrganisations.filter((org: Organisation) => {
      const addingOrg = this.orgsToAdd.map((ota: Organisation) => ota.id).includes(org.id);
      const hasOrg = this.user.organisations.map((o: Organisation) => o.id).includes(org.id) || false;

      return !addingOrg && !hasOrg;
    });
  }
}
